var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.625 0 12-5.375 12-12S18.625 0 12 0 0 5.375 0 12s5.375 12 12 12zm1.438-9.5h-2.891c-.297 0-.531-.172-.531-.39L9.75 4.405c0-.11.047-.218.156-.281A.602.602 0 0 1 10.281 4h3.438c.14 0 .281.047.375.125.11.063.156.172.156.281l-.281 9.703c-.016.22-.25.391-.531.391zm.078 5.5h-3a.52.52 0 0 1-.516-.516v-2.968a.52.52 0 0 1 .516-.516h3c.265 0 .484.234.484.516v2.968c0 .282-.219.516-.484.516z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconWhite);
export default __webpack_public_path__ + "static/media/error-icon-white.e845880ae922d4030c2ff445a3b84597.svg";
export { ForwardRef as ReactComponent };